export enum SubscriptionBillingCycleEnum {
    YEARLY = "YEARLY",
    QUARTERLY = "QUARTERLY",
    BIMONTHLY = "BIMONTHLY",
    MONTHLY = "MONTHLY",
}

export enum SubscriptionPlanCategoryEnum {
    FREE = "FREE",
    CORE = "CORE",
    RISE = 'RISE',
    GROWTH = "GROWTH",
    ENTERPRISE = "ENTERPRISE",
    WATAN = "WATAN",
}

export enum SubscriptionStatusEnum {
    ACTIVE = "ACTIVE",
    ON_HOLD = "ON_HOLD",
    CANCELED = "CANCELED",
    INACTIVE = "INACTIVE",
}

export enum PartnerTrialStatusEnum {
    NOT_STARTED = 'NOT_STARTED',
    STARTED = 'STARTED',
    ENDED = 'ENDED',
}
